import {createActions, createState, createReducer} from 'reduxsauce-crud'
import Immutable from 'seamless-immutable'
import R from 'ramda'
const d = {deep: true}

export const ServiceOccasionalRedux = createActions(
  {
    // Custom actions
    postServiceOccasionalRequest: ['centerId', 'data'],
    postServiceOccasionalSuccess: [''],
    postServiceOccasionalFail: ['error'],
    exportServiceOccasionalRequest: ['centerId'],
    exportServiceOccasionalSuccess: [''],
    exportServiceOccasionalFail: ['error'],
    deleteServiceOccasionalRequest: ['centerId', 'occasionalId'],
    deleteServiceOccasionalSuccess: ['occasionalId'],
    deleteServiceOccasionalFail: ['error'],
  },
  {
    prefix: 'SERVICE_OCCASIONAL_',
    defaultActions: {
      get: true,
    },
  },
)

const {Types, Creators} = ServiceOccasionalRedux
export const ServiceOccasionalTypes = Types
export default Creators

export const INITIAL_STATE = createState({
// custom state
    sending: {
      fetching: false,
      error: null,
    }
  },
  {
    get: true,
  })


const exportServiceOccasionalRequest = state => state.merge({sending: {fetching: true, error: null}}, d)
const exportServiceOccasionalSuccess = state => state.merge({sending: {fetching: false, error: null}}, d)
const exportServiceOccasionalFail = (state, {error}) => state.merge({sending: {fetching: false, error}}, d)

const postServiceOccasionalRequest = state => state.merge({sending: {fetching: true, error: null}}, d)
const postServiceOccasionalSuccess = state => state.merge({sending: {fetching: false, error: null}}, d)
const postServiceOccasionalFail = (state, {error}) => state.merge({sending: {fetching: false, error}}, d)

const deleteServiceOccasionalRequest = state => state.merge({sending: {fetching: true, error: null}}, d)
const deleteServiceOccasionalSuccess = (state, {occasionalId}) => {
  const { data } = R.clone(state.get.results)
  const filteredData = data.filter(item => item.id !== occasionalId)
  return state.merge({sending: {fetching: false, error: null}, get: {results: {data: filteredData}}}, d)
}
const deleteServiceOccasionalFail = (state, {error}) => state.merge({sending: {fetching: false, error}}, d)

export const reducer = createReducer(
  INITIAL_STATE, {
    // custom reducers
    [Types.exportServiceOccasionalRequest]: exportServiceOccasionalRequest,
    [Types.exportServiceOccasionalSuccess]: exportServiceOccasionalSuccess,
    [Types.exportServiceOccasionalFail]: exportServiceOccasionalFail,
    [Types.postServiceOccasionalRequest]: postServiceOccasionalRequest,
    [Types.postServiceOccasionalSuccess]: postServiceOccasionalSuccess,
    [Types.postServiceOccasionalFail]: postServiceOccasionalFail,
    [Types.deleteServiceOccasionalRequest]: deleteServiceOccasionalRequest,
    [Types.deleteServiceOccasionalSuccess]: deleteServiceOccasionalSuccess,
    [Types.deleteServiceOccasionalFail]: deleteServiceOccasionalFail,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ServiceOccasionalRedux.js